// Глобальные константы

export const define = {
    pathToGraphics: '', //путь к графическим элементам
    pathToAPI: '', // путь к API
}

if(window.location.hostname === 'localhost'){
    define.pathToGraphics = 'http://api-cms/_graphics'
    define.pathToAPI =  'http://api-cms'
} else {
    define.pathToGraphics = 'https://massaclub.com/api-cms/_graphics'
    define.pathToAPI = 'https://massaclub.com/api-cms'
}

define.uploadsFolder = define.pathToAPI + '/multiupload/uploads/'
define.prevFolder = define.pathToAPI + '/multiupload/uploads/40px/'


export const maxNameLength = 49 // максимальная длина имени файла (картинки). Если имя длиннее - будем сокращать при отображении
export const tokenLifeTimeInfo= '5 минут' // Время жизни токена (для инфо сообщений)


// Уведомления
export const defNotifyDuration = 14000 // Длительность показа уведомлений по умолчанию (секунд * 1000мс)
export const welcNotifyDuration = 15000 // Длительность показа welcome уведомления (секунд * 1000мс)
export const tokenExpiredMsg = "Срок действия токена истек.<br>Доступ ограничен.<p class='mt-10'>Поделитесь мнением с разработчиком. Напишите свои замечания или советы на <span class='nowrap'><img src='" + define.pathToGraphics + "/mail_16px.png' alt=''/><a href='mailto:web-design@ukr.net' class='mail'>web-design@ukr.net</a></span></p><p class='mt-10'>Хотите продолжить знакомство с приложением? Обновите страницу и снова откройте доступ.</p>"
export const expNotifyDuration = 1641000 // Длительновть показа уведомления "Срок действия токена истек" (секунд * 1000мс)


// // TinyMCE
// // export const tinyContentCss = 'https://api-catalog/test-tinymce/bootstrap.css'
// export const tinyContentCss = 'https://cdn.jsdelivr.net/npm/bootstrap@5.2.1/dist/css/bootstrap.min.css'
